import { render, staticRenderFns } from "./DevicesNew.vue?vue&type=template&id=60ed7b9c&scoped=true"
import script from "./DevicesNew.vue?vue&type=script&lang=js"
export * from "./DevicesNew.vue?vue&type=script&lang=js"
import style0 from "./DevicesNew.vue?vue&type=style&index=0&id=60ed7b9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ed7b9c",
  null
  
)

export default component.exports